module.exports = __webpack_public_path__ + "img/c0d9b98.png";